import { useRef, useEffect } from 'react';

// Uses Dan Abramov's declarative setInterval
// https://overreacted.io/making-setinterval-declarative-with-react-hooks/
export type callbackType = () => void;
export const useInterval = (
  callback: callbackType,
  delay: number | null
): void => {
  const savedCallback = useRef<callbackType>(callback);

  // Remember the latest function.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    const tick = (): void => {
      savedCallback.current();
    };
    if (delay !== null) {
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    } else {
      return () => {
        return null;
      };
    }
  }, [delay]);
};
